import { render, staticRenderFns } from "./TradingViewChart.vue?vue&type=template&id=32d9a355&scoped=true"
import script from "./TradingViewChart.vue?vue&type=script&lang=js"
export * from "./TradingViewChart.vue?vue&type=script&lang=js"
import style0 from "./TradingViewChart.vue?vue&type=style&index=0&id=32d9a355&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d9a355",
  null
  
)

export default component.exports